import React from "react";
import { trackingColors } from "../utils/common";
import styles from "./FlausFlosserConfirmLink.module.css";

const FlausFlosserConfirmLink = ({ orderData, trackingStatus, trackingCode, logoUrl, itemQuantity }) => {
  const trackingColor = trackingColors[trackingStatus] || "gray";
  const trackingLabel = trackingStatus
    ? trackingStatus.replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase())
    : "Unknown";

  return (
    <div className={styles.container}>
      {/* Logo — same size as LogoWrapper on initial portal render */}
      {logoUrl && (
        <div className={styles.logo_wrapper}>
          <img
            src={`${process.env.PUBLIC_URL}/business_images/${logoUrl}`}
            alt="Flaus"
            className={styles.logo}
          />
        </div>
      )}

      {/* Heading block — no "Details and tracking status" title */}
      <div className={styles.heading_block}>
        <p className={styles.email_line}>
          Return label sent to {orderData?.customer_email}
        </p>
        <p className={styles.save_link}>(Save this link for tracking updates)</p>
      </div>

      {/* Product card — Order # | Flosser Box | flosser_box.png */}
      <div className={styles.card}>
        <div className={styles.product_row}>
          <span className={styles.order_number}>Order #{orderData?.order_id}</span>
          <span className={styles.product_name}>
            {orderData?.products?.[0]?.product_title || "Flosser Box"}
          </span>
          <img
            src={`${process.env.PUBLIC_URL}/images/flosser_box.png`}
            alt="Flosser Box"
            className={styles.product_img}
          />
        </div>
      </div>

      {/* Details card */}
      <div className={styles.card}>
        <p className={styles.returning_count}>
          Returning {itemQuantity ?? 1} {(itemQuantity ?? 1) === 1 ? "item" : "items"}
        </p>

        <div className={styles.detail_row}>
          <span className={styles.detail_label}>Tracking Status:</span>
          <span className={styles.detail_value} style={{ color: trackingColor }}>
            {trackingLabel}
          </span>
        </div>

        <div className={styles.detail_row}>
          <span className={styles.detail_label}>Tracking Code:</span>
          <span className={styles.detail_value}>{trackingCode || "—"}</span>
        </div>

        <div className={styles.detail_row}>
          <span className={styles.detail_label}>Customer name</span>
          <span className={styles.detail_value}>{orderData?.customer_name}</span>
        </div>

        <div className={styles.detail_row}>
          <span className={styles.detail_label}>Customer address</span>
          <span className={`${styles.detail_value} ${styles.address_value}`}>
            {orderData?.customer_address}
          </span>
        </div>
      </div>
    </div>
  );
};

export default FlausFlosserConfirmLink;
